export default __webpack_public_path__ + "static/media/67010fed89bc413fbb1f2e5833073b2d-23-1280-768x455.65ad75d9.jpg";